module.exports = __webpack_public_path__ + "img/paula.8406612e.png";